import { createContext, useContext } from "react";
import en from "./en";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => (
  <I18nContext.Provider value={{ lang: "en", setLang: () => {}, t: en }}>{children}</I18nContext.Provider>
);

export const useI18n = () => useContext(I18nContext);

